<h2 mat-dialog-title>{{'pass.map.ANNOTATIONS_dynamic' | translate}}</h2>

<mat-dialog-content>

  <div class="hint-text">{{'dynamic_coordinates_hint' | translate}}</div>

  <div class="py-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
      <form [formGroup]="propertiesForm">

        <div>
          <div class="text-muted pb-4">{{'pass.map.coordinate' | translate}}</div>

          <div class="d-flex flex-row">
            <div class="pe-2 flex-grow-1">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'pass.map.latitude' | translate}}</mat-label>
                <input matInput type="text" id="newLat" formControlName="lat" placeholder="{{'pass.map.latitude' | translate}}" >
              </mat-form-field>
            </div>
            <div class="ps-2 flex-grow-1">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'pass.map.longitude' | translate}}</mat-label>
                <input matInput type="text" id="newLng" formControlName="lng"  placeholder="{{'pass.map.longitude' | translate}}">
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="d-flex flex-row">
          <div class="pe-2 flex-grow-1">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.map.title' | translate}}</mat-label>
              <input matInput type="text" id="titleMap" formControlName="title" placeholder="{{'pass.title' | translate}}">
            </mat-form-field>
          </div>
          <div class="ps-2 flex-grow-1">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.map.subtitle' | translate}}</mat-label>
              <input matInput type="text" id="subtitleMap" formControlName="subtitle" placeholder="{{'pass.subtitle' | translate}}">
            </mat-form-field>
          </div>
        </div>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.map.badge' | translate}}</mat-label>
          <input matInput type="text" id="bagdeMap" formControlName="badge" placeholder="{{'pass.map.badge' | translate}}">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.link-URL' | translate}}</mat-label>
          <input matInput type="url" id="linkURLMap" formControlName="linkURL" placeholder="{{'pass.link-URL' | translate}}">
          <mat-error>
            {{'url_pattern_invalid' | translate}}
          </mat-error>
        </mat-form-field>

        <div>
          <div class="text-muted text-uppercase pb-3">{{'style' | translate}}</div>
          <div class="list-group">
            <div class="list-group-item p-2 ps-3 pe-3">
              <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                <span class=" w-50 bg-white" >{{'pinBackgroundColor' | translate}}</span>
                <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                  <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="pinBackgroundColor" style="margin-left:10px;"></ngx-colors>
                  @if (invalid_pinBackgroundColor) {
                    <span id="invalid_pinBackgroundColor" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                  }
                </label>
              </div>
            </div>

            <div class="list-group-item p-2 ps-3 pe-3">
              <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                <span class=" w-50 bg-white" >{{'pinForegroundColor' | translate}}</span>
                <label class=" d-flex flex-row-reverse justify-content-start align-items-center" style="border-left:none;" >
                  <ngx-colors ngx-colors-trigger [palette]="colorPalette" [hideTextInput]="false" [format]="'hex'" cancelLabel="{{'pass.colorPickerCancel' | translate}}" acceptLabel="{{'pass.colorPickerConfirm' | translate}}" formControlName="pinForegroundColor" style="margin-left:10px;"></ngx-colors>
                  @if (invalid_pinForegroundColor) {
                    <span id="invalid_pinForegroundColor" style="color:red;">{{'pass.invalid_color' | translate}}</span>
                  }
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" [mat-dialog-close]="[false]" >
    {{'cancel' | translate}}
  </button>
  <button mat-button [disabled]="invalid_pinBackgroundColor || invalid_pinForegroundColor || !propertiesForm.valid" class="orange-button" (click)="onSaveEdit();" >
    {{'save' | translate}}
  </button>
</mat-dialog-actions>
